import { FC } from 'react';
import { CustomModal } from 'components/uikit/modal/CustomModal.tsx';
import { Button, ButtonColor } from 'components/uikit/buttons/Button.tsx';
import { QueryFactory } from 'services/api';
import styles from './ResendNotificationModal.module.scss';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { Trans } from 'react-i18next';
import { Loading } from 'components/uikit/suspense/Loading.tsx';

export type ResendNotificationModalProps = {
  revisionId: number;
  documentId: number;
  isOpen: boolean;
  onClose: () => void;
};

export const ResendNotificationModal: FC<ResendNotificationModalProps> = (
  props,
) => {
  const i18n = useScopedTranslation('Component.ResendNotificationModal');
  const buttonTitle = useScopedTranslation('Button.Title');
  const signerToResendNotifications =
    QueryFactory.DocumentSigningQuery.useGetSignerToResendNotificationsQuery(
      props.revisionId,
      { enabled: !!props.revisionId && props.isOpen },
    );
  const signerToResendNotification = signerToResendNotifications.data?.find(
    (dto) => dto.documentId === props.documentId,
  );

  const signerFullName =
    signerToResendNotification?.signer.firstName +
    ' ' +
    signerToResendNotification?.signer.lastName;

  return (
    <CustomModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      isBlocking={true}
      title={i18n.t('title')}
    >
      <Loading loading={signerToResendNotifications.isLoading}>
        <div className={styles.message}>
          {signerToResendNotification ? (
            <Trans
              i18nKey={'Component.ResendNotificationModal.message_exists'}
              values={{
                roleName: signerToResendNotification?.roleName,
                signerName: signerFullName,
              }}
              components={{
                bold: <b />,
                pre: <span className={styles.noWhiteSpace} />,
              }}
            />
          ) : (
            i18n.t('message_do_not_exist')
          )}
        </div>
        <div className={styles.footer}>
          <Button
            title={buttonTitle.t('cancel')}
            color={ButtonColor.Secondary}
            className={styles.button}
            onClick={props.onClose}
          />
          {signerToResendNotification && (
            <Button
              testId={'send-button'}
              title={buttonTitle.t('confirm')}
              color={ButtonColor.Primary}
              className={styles.button}
              onClick={async () => {
                await QueryFactory.DocumentSigningClient.resendNotificationToSigner(
                  props.documentId,
                );
                props.onClose();
              }}
            />
          )}
        </div>
      </Loading>
    </CustomModal>
  );
};
